<script>
	let className = '';
	export { className as class };
	export let width = '135';
	export let height = '45';
	export let fontSize;
	export let disabled = true;
	export let onClick = () => {};
	export let onMouseDown = () => {};
	let lineHeight;

	$: if (fontSize) {
		lineHeight = fontSize * 1.4;
	}
</script>

<button
	class={className}
	{disabled}
	class:disabled
	on:mousedown={onMouseDown}
	on:click={onClick}
	style="--width: {width}px; --height: {height}px; --fontSize: {fontSize}px; --lineHeight: {lineHeight}px;"
>
	<slot />
</button>

<style>
	.disabled {
		cursor: not-allowed;
		filter: brightness(70%);
	}
</style>
